import React, { Component } from 'react';

export default class Spinner extends Component {

  render() {
    return (<img alt="spinner" className="spinner" src={require('../spinner.png')}></img>);
  }
}
